import RecommendedProductRequestModel from './recommended-products-request.model';
var RecommendedProductsService = /** @class */ (function () {
    function RecommendedProductsService($http, $q, $window, CommonDataService) {
        'ngInject';
        this.$http = $http;
        this.$q = $q;
        this.$window = $window;
        this.CommonDataService = CommonDataService;
    }
    /***
     * typeahead - Makes request to get the type ahead and also builds a model to return to UI
     * @param searchTerm
     */
    RecommendedProductsService.prototype.getRequestModel = function (searchTerm) {
        return new RecommendedProductRequestModel(searchTerm, this.$http, this.$q, this.$window, this.CommonDataService);
    };
    ;
    return RecommendedProductsService;
}());
export default RecommendedProductsService;
//# sourceMappingURL=recommended-products.service.js.map